import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from "react-helmet";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';
import TapHelper from '../../services/TapHelper';
import { DisplayListPagination } from '../../components/TapUi';
import DateService from '../../services/DateService';
import TapIcon from '../../services/TapIcon';

const NotificationLogList = forwardRef((props, ref) => {

    let initListData = {
        loading: false,
        items: [],
        meta: null,
        page: 1
    };

    let itemListUrl = ORG_API_BASE_URL_2 + "/log/notification/list";
    const access_token = useSelector(state => state.auth.access_token);

    const [itemsData, setItemsData] = useState({ ...initListData });

    useEffect(() => {
        loadItemsData(1);
    }, []);

    const loadItemsData = (page = 1) => {
        setItemsData(pd => ({ ...pd, loading: true, page: page }));
        let params = {
            page: page,
        };

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            let respData = response.data?.data;
            let meta = TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setItemsData(pd => ({ ...pd, items: respData.data || [], meta: meta }));
        }).finally(() => {
            setItemsData(pd => ({ ...pd, loading: false }));
        });
    };


    const notificationListJsx = () => {
        return <>
            <table className="table table-sm table-bordered align-middle bg-white table-fixed">
                <thead className="align-middle table-secondary">
                    <tr className='text-center'>
                        <th style={{ width: "5%" }}>S.No</th>
                        <th style={{ width: "15%" }}>Title</th>
                        <th style={{ width: "30%" }}>Body</th>
                        <th style={{ width: "15%" }}>Type</th>
                        <th style={{ width: "15%" }}>Status</th>
                        <th style={{ width: "25%" }}>Send At</th>
                    </tr>
                </thead>
                <tbody>
                    {itemsData.loading
                        ? <tr><td className='text-center' colSpan={6}><Loader /></td></tr>
                        : ((itemsData.items && itemsData.items.length > 0)
                            ? itemsData.items.map((item, index) => {
                                return (
                                    <tr key={item.id} className='text-center'>
                                        <td>{(itemsData.meta?.current_page - 1) * itemsData.meta?.per_page + index + 1}</td>
                                        <td className='text-start'>{item?.title || "-"}</td>
                                        <td className='text-start'>{item?.body || item?.message || "-"}</td>
                                        <td>{item?.type_name || "-"}</td>
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <span style={{
                                                    width: 15, height: 15, borderRadius: "50%",
                                                    display: "inline-block",
                                                    backgroundColor:
                                                        item.is_read === 0 ? "#2b7cff" : "#28a745"
                                                }}
                                                ></span>
                                                <span>
                                                    {item.is_read === 0 ? "Unread" : "Read"}
                                                </span>

                                            </div>
                                        </td>
                                        <td>{item?.sent_at ? DateService.dateTimeFormat(item.sent_at, 'DD-MMM-YYYY HH:mm:ss') : "-"}</td>
                                    </tr>
                                );
                            })
                            : <tr><td className='text-center' colSpan={6}>No Records</td></tr>)
                    }
                </tbody>
            </table>

            <DisplayListPagination meta={itemsData.meta} onPageChange={(e) => loadItemsData(e.selected + 1)} />
        </>;
    };
    const handleRefresh = () => {
        loadItemsData(1);
    }

    const pageHeading = () => {
        return (<>
            <Helmet><title>Notification Logs</title></Helmet>
            <div className="page_title m0 row align-middle">
                <div className='col-sm-12'>
                    <div className="d-flex align-items-center justify-content-between ">
                        <h3 className='mb-0'>Notification Logs</h3>
                        <button type="button" className="btn btn-secondary btn-sm ml0 mt-2" disabled={itemsData?.loading} onClick={handleRefresh} >
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className={[itemsData?.loading ? 'fa-spin' : ''].join(" ")} />
                        </button>
                    </div>
                </div>
            </div>
        </>);
    };

    return <ApplicationLayout>
        {pageHeading()}
        <div className="container-fluid pl5">
            <div className='page_containt row'>
                <div className='pageTbl col-sm-12'>{notificationListJsx()}</div>
            </div>
        </div>
    </ApplicationLayout>;

});

export default NotificationLogList;